// Values for the data-mdlfy-cms attribute, which makes a database text value
// editable straight from the preview. The format is <table>:<row id>:<column>,
// always with the real column name from the database, never a JS property name.
// Safe to import from components.

export type WeddingTextColumn =
    | 'couple'
    | 'title'
    | 'wedding_type'
    | 'location'
    | 'venue'
    | 'wedding_month'
    | 'guest_count'
    | 'excerpt'
    | 'quote'
    | 'quote_by'

export const weddingField = (id: string, column: WeddingTextColumn): string => `weddings:${id}:${column}`
